import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip, { TooltipProps } from "@material-ui/core/Tooltip";

type Props = Partial<TooltipProps>;

/**
 * Wraps children with a tooltip.
 * Renders only children (no tooltip) if title is not provided
 */
export function WithTooltip(props: Props) {
  const classes = useStyles({});
  const { children, title, ...rest } = props;

  return title ? (
    <Tooltip title={title} className={classes.root} {...rest}>
      {props.children}
    </Tooltip>
  ) : (
    props.children
  );
}

const useStyles = makeStyles(() => ({
  root: {
    "& > *": {
      pointerEvents: "all"
    }
  }
}));

export default WithTooltip;
